<template>
  <b-card bg-variant="light" class="rounded-0 border-0">
    <address class="text-right">
      <div v-if="contractPartner">
        <div>{{ contractPartner.contractPartnerName }}</div>
        <div>
          {{ contractPartner.street }} {{ contractPartner.streetNumber }}<br/>
          {{ contractPartner.postalCode + ' ' + contractPartner.city }}<br/>
          {{ contractPartner.postOfficeBox }}
        </div>
      </div>
    </address>
    <address>
      <div v-if="contractAddress">
        <div>{{ fullName }}</div>
        <span v-if="contractAddress.street">{{ contractAddress.street }}</span> <span v-if="contractAddress.streetNumber">{{ contractAddress.streetNumber }}</span> 
        <div v-if="contractAddress.postalCode">{{ contractAddress.postalCode }} <span v-if="contractAddress.city">{{ contractAddress.city }}</span>
        </div>
      </div>
    </address>
    <div>
      <div class="mb-3"><b>{{ contractCategoryText }}</b></div>
      <div v-if="contract.contractType">{{ $t('message.contractInformationForm.label.contractType') }}:
        {{ contract.contractType }}
      </div>
      <div v-if="contract.contractNumber">{{ contractNumberText }}:
        {{ contract.contractNumber }}
      </div>
      <div v-if="contract.accountNumber">{{ $t('message.contractInformationForm.label.accountNumber') }}:
        {{ contract.accountNumber }}
      </div>
      <div v-if="contract.insuredPersonNumber">{{ $t('message.contractInformationForm.label.insuredPersonNumber') }}:
        {{ contract.insuredPersonNumber }}
      </div>
      <div v-if="contract.conclusionDate">{{ $t('message.contractInformationForm.label.conclusionDate') }}:
        {{ contract.conclusionDate | moment('DD.MM.YYYY') }}
      </div>
      <div v-if="contract.contractDuration">{{ $t('message.contractInformationForm.label.contractDuration') }}:
        {{ contract.contractDuration }} {{ $t('message.contractInformationForm.label.months') }}
      </div>
      <div v-if="contract.cancellationPeriod">{{ $t('message.contractInformationForm.label.cancellationPeriod') }}:
        {{ contract.cancellationPeriod }}
        {{ $t('message.contractInformationForm.label.months') }}
      </div>
      <div v-if="contract.accountUsername">{{ $t('message.contractInformationForm.label.username') }}:
        {{ contract.accountUsername }}
      </div>
      <div v-if="contract.accountLink">{{ $t('message.contractInformationForm.label.link') }}:
        {{ contract.accountLink }}
      </div>
      <div v-if="contract.link">{{ $t('message.contractInformationForm.label.link') }}: {{ contract.link }}</div>
      <div v-if="contract.comment">{{ $t('message.contractInformationForm.label.comment') }}: {{ contract.comment }}
      </div>
    </div>
  </b-card>
</template>

<script>
  export default {
    name: 'ContractSummary',
    props: {
      contract: {
        type: Object,
        required: true
      },
      contractCategories: {
        type: Array,
        required: true
      }
    },
    computed: {
      contractAddress () {
        return this.contract.address
      },
      contractPartner () {
        return this.contract.contractPartner
      },
      contractCategoryText () {
        if (this.contract.contractCategory) {
          const filteredCategories = this.contractCategories.filter(contractCategory => (contractCategory.value === this.contract.contractCategory))
          if (filteredCategories.length > 0) {
            return filteredCategories[0].text
          }
        }
        return ''
      },
      contractNumberText () {
        return this.contract.contractCategory === 'INSURANCE' ? this.$t('message.contractInformationForm.label.insuranceNumber')
          : this.$t('message.contractInformationForm.label.contractNumber')
      },
      fullName () {
        const currentUser = this.$store.getters.currentUser
        if (currentUser) {
          return `${currentUser.firstName} ${currentUser.lastName}`
        } else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractSummary.vue